var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChair4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C8.85916 2 6.47004 4.82026 6.98639 7.91836L8 14H6C5.44772 14 5 14.4477 5 15V17C5 17.5523 5.44772 18 6 18H6.25V22C6.25 22.4142 6.58579 22.75 7 22.75C7.41421 22.75 7.75 22.4142 7.75 22V18H9.25V20C9.25 20.4142 9.58579 20.75 10 20.75C10.4142 20.75 10.75 20.4142 10.75 20V18H13.25V20C13.25 20.4142 13.5858 20.75 14 20.75C14.4142 20.75 14.75 20.4142 14.75 20V18H16.25V22C16.25 22.4142 16.5858 22.75 17 22.75C17.4142 22.75 17.75 22.4142 17.75 22V18H18C18.5523 18 19 17.5523 19 17V15C19 14.4477 18.5523 14 18 14H16L17.0136 7.91836C17.53 4.82026 15.1408 2 12 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair4);
export default __webpack_public_path__ + "static/media/chair-4.d826cad03ed9a0dced78afff0d000607.svg";
export { ForwardRef as ReactComponent };